import { render, staticRenderFns } from "./HeaderBreadcrumb.vue?vue&type=template&id=570512f2"
import script from "./HeaderBreadcrumb.vue?vue&type=script&lang=js"
export * from "./HeaderBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./HeaderBreadcrumb.vue?vue&type=style&index=0&id=570512f2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570512f2')) {
      api.createRecord('570512f2', component.options)
    } else {
      api.reload('570512f2', component.options)
    }
    module.hot.accept("./HeaderBreadcrumb.vue?vue&type=template&id=570512f2", function () {
      api.rerender('570512f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/HeaderBreadcrumb.vue"
export default component.exports